import React, {useEffect} from "react";
import { Footer, Header } from "../Components";
import FooterTopBar from "../Components/FooterTopBar";

export const TermsOfUse = () => {
  document.title = "Disclaimer & Terms of Use - Famra Cure";
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-left mb-8 text-sky-800">
            Disclaimer
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-8 text-center font-semibold">
              Please review these Terms of Use carefully. They apply to all Famra Cure online Services, including our website, mobile applications, and digital tools.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Use of Medical Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                All content provided by famracure.com across our website, mobile app, and social media platforms (including Facebook, Instagram, Twitter, and YouTube) is for <strong>general informational purposes only</strong>. It is not a substitute for professional medical advice, diagnosis, or treatments.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">No Warranties</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                While we strive for accuracy, the text, graphics, and images on our platforms are provided "as is" We make no guarantees, express or implied, regarding the reliability, validity, or completeness of this information.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Famra Cure shall not be held liable for any loss or damage resulting from your use of or reliance on information found on our platforms. Use of our services is at your own discretion and risk.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Medical Emergencies</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Do not use this service for emergencies.</strong> If you are experiencing a medical emergency, call your local emergency helpline or seek immediate professional care.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Medical Disclaimer & Provider Relationship</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The information on this site is for general purposes and does not substitute for professional medical care. Using this website does not create a doctor-patient relationship.
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-4">
                <li>
                  <strong>Establishing a Relationship:</strong> A formal doctor-patient relationship is only formed once you book a direct appointment. In these instances, Famra Cure acts strictly as a third-party facilitator. We are not responsible for the medical advice, opinions, or treatment provided by the healthcare professional, whether the consultation is online or in person.
                </li>
                <li>
                  <strong>Seek Professional Counsel:</strong> Always consult with a qualified healthcare provider regarding medical conditions or treatments. Never ignore or delay seeking professional medical advice because of something you have read on Famra cure's website or social media channels.
                </li>
                <li>
                  <strong>Independent Medical Opinions:</strong> Doctors on our platform provide independent advice based on their own clinical expertise. Famra Cure is not liable for any medical opinions or services delivered by these independent professionals via our portals or in-person bookings.
                </li>
                <li>
                  <strong>Verification of Credentials:</strong> Users are strongly advised to independently verify a provider's credentials and education. This includes contacting the healthcare provider's office directly or checking with the <strong>Pakistan Medical and Dental Council (PMDC)</strong> and relevant medical associations prior to booking.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Endorsements & Products</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-4">
                <li>
                  <strong>Trademarks:</strong> Logos and brand names belong to their respective owners and do not imply an endorsement by us.
                </li>
                <li>
                  <strong>Product Info:</strong> We do not guarantee the safety or efficacy of any drugs or treatments mentioned. Always consult a professional for specific medical advice.
                </li>
                <li>
                  <strong>Neutrality:</strong> Famra cure does not recommend or favor specific doctors, tests, or providers listed on our digital platforms.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Doctor Profiles & Personal Opinions</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-4">
                <li>
                  <strong>Verified Information:</strong> We strive for accuracy in our doctor profiles, but we cannot warrant that all training or credential details are always up-to-date or error-free.
                </li>
                <li>
                  <strong>Personal Beliefs:</strong> Any medical, religious, or political views expressed by doctors on our platform are their own and are not endorsed by Famra Cure.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Links to Other Websites</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-4">
                <li>
                  <strong>Outside Content:</strong> We may link to other websites, but we don't control or check them for accuracy or reliability.
                </li>
                <li>
                  <strong>No Endorsement:</strong> Famra Cure isn't responsible for what you find on third-party sites. A link doesn't mean we endorse the content or services offered there.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Privacy & Liability</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Privacy Commitment:</strong> At Famra Cure, protecting your privacy is our top priority. We handle all patient information with the utmost care. Our policy outlines how we collect, use, and safeguard your data. For any questions regarding your privacy, please contact us at <a href="mailto:info@famracure.com" className="font-bold text-sky-800 hover:text-sky-600 transition-colors">info@famracure.com</a>.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Famra Cure, its affiliates and contractors are not liable for any personal injury, harm, or infringement resulting from the use or misuse of our services, content, or community comments. Under no circumstances shall Famra Cure or its employees be held responsible for any direct, incidental, or consequential damages.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Famra Cure makes every reasonable effort to ensure that participating healthcare providers hold the active legal licenses required for their specialties. We also reserve the right to remove any provider who, at our discretion, demonstrates inappropriate or unprofessional conduct.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Service Market Place</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The Famra Cure Platform functions exclusively as a digital intermediary connecting Users with third-party healthcare Providers. Each service rendered constitutes a distinct agreement between the User and the Provider. Regarding virtual consultations, Users acknowledge that digital visits differ from physical ones; consequently, Famra Cure and the respective Providers disclaim liability for any resulting direct or indirect losses.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Status of Providers</h2>
              <p className="text-gray-700 leading-relaxed mb-4 uppercase font-semibold">
                You acknowledge that Famra Cure is not a medical provider. All services are rendered by independent contractors, not employees or agents of Famra Cure.
              </p>
            </section>

            <p className="text-sm text-gray-600 mt-8 pt-4 border-t">
              Last Updated: June 2026
            </p>
          </div>
        </div>
      </div>
      <FooterTopBar />
      <Footer />
    </>
  );
};

export default TermsOfUse;
